import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'number_on_site_dormitories'

export const dataPointDefinition = {
  retracedId: 'number_on_site_dormitories',
  name: 'Number of on-site dormitories:',
  description:
    'Include all dormitories on facility premises, regardless of who lives in the dormitory and who manages the dormitory.',
  meta: {
    slcpMeta: {
      key: 'fp-bs-5',
      number: 'FP-BUI-5',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {type: 'object', properties: {value: {type: 'string'}}, required: ['value']},
  externalIds: [{id: 'fp-bs-5', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27250,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
